import { Label } from '@/components/base/label'
import type { SwitchProps } from '@/components/base/switch'
import { Switch } from '@/components/base/switch'
import { useRoomStore, useRoomStoreActions } from '@/stores/room'
import { useId } from 'react'

type SwitchAutoGainControlProps = Omit<
  SwitchProps,
  'checked' | 'id' | 'onCheckedChange'
>

export const SwitchMirrorLocalVideo = ({
  ...props
}: SwitchAutoGainControlProps) => {
  const mirrorLocalOverlay = useRoomStore(state => state.mirrorLocalOverlay)

  const { setMirrorLocalOverlay } = useRoomStoreActions()

  const mirrorVideoId = useId()

  const handleChange = (value: boolean) => {
    setMirrorLocalOverlay(value)
  }

  return (
    <>
      <Label htmlFor={mirrorVideoId}>Mirror Video</Label>
      <Switch
        id={mirrorVideoId}
        checked={mirrorLocalOverlay}
        onCheckedChange={handleChange}
        {...props}
      />
    </>
  )
}
